module.exports = __webpack_public_path__ + "static/media/multiverse4.866b9a90.png";